import * as React from 'react';

import { StyleSheet, css } from '@coursera/coursera-ui';

import Button from 'bundles/coursera-ui/components/basic/Button';

type Props = {
  // Original propType: node
  svgElement?: React.ReactElement;
  // Original propType: object
  htmlAttributes?: $TSFixMe;
  // Remaining props are forwarded to the underlying Button
  [key: string]: $TSFixMe;
};

type State = {
  hovered: boolean;
};

const CONFIG = {
  iconMargin: '0.6rem',
};

const styles = StyleSheet.create({
  iconWrapper: {
    display: 'inline-block',
  },
  iconLeft: {
    marginRight: CONFIG.iconMargin,
  },
  iconRight: {
    marginLeft: CONFIG.iconMargin,
  },
});

/**
 * A Button that handles interaction when having svg icon as children
 */
class SvgButton extends React.Component<Props, State> {
  static defaultProps = {
    htmlAttributes: {},
  };

  state = {
    hovered: false,
  };

  handleMouseLeave = (e: $TSFixMe) => {
    this.setState({ hovered: false });
    if (this.props.htmlAttributes.onMouseLeave) {
      this.props.htmlAttributes.onMouseLeave(e);
    }
  };

  handleMouseEnter = (e: $TSFixMe) => {
    this.setState({ hovered: true });
    if (this.props.htmlAttributes.onMouseEnter) {
      this.props.htmlAttributes.onMouseEnter(e);
    }
  };

  render() {
    const { svgElement, htmlAttributes, ...rest } = this.props;

    return (
      <Button
        {...rest}
        htmlAttributes={{
          ...htmlAttributes,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
        }}
      >
        {svgElement && (
          <span
            {...css(
              styles.iconWrapper,
              rest.label && !rest.isChildrenOnRight && styles.iconLeft,
              rest.label && rest.isChildrenOnRight && styles.iconRight
            )}
          >
            {svgElement &&
              React.cloneElement(svgElement, {
                hovered: this.state.hovered,
                disableMouseEvent: true,
              })}
          </span>
        )}
      </Button>
    );
  }
}

export default SvgButton;
